








import {Component, Vue} from "vue-property-decorator";
import {getImageUrl} from "@common/ImageUrlHelper";

@Component({
    name: "WebConferencesRecordingLayout"
})
export default class WebConferencesRecordingLayout extends Vue {
    get selectedEventObject() {
        return this.$store.getters['events/selectedEvent'];
    }

    get backgroundImageUrl(): string {
        const backgroundFileId = this.selectedEventObject?.backgroundFileId;

        return backgroundFileId ? getImageUrl(this.$route.params.backend, backgroundFileId) : '';
    }
}
